export var portTemplateModel = {
   'name': {
      'title': "Name",
      'display': true
   }
};